import { useState } from "react";
import Checkbox from "../CheckBox/CheckBox";
import "./segment.css";

const Segment = ({ name, change, data, level }) => {
  const [checked, setChecked] = useState(false);
  return (
    <div className="segment-wrapper">
      <div className="segment" style={{ marginLeft: `${level * 11}%` }}>
        <Checkbox
          label={name}
          value={change}
          setChecked={setChecked}
          checked={checked}
        ></Checkbox>
      </div>
      {data.length !== 0 &&
        checked &&
        data.map((segment) => {
          return (
            <Segment
              name={segment.name}
              change={segment.change}
              data={segment.data}
              level={level + 1}
            />
          );
        })}
      {level === 0 && <div className="segment-line "></div>}
    </div>
  );
};

export default Segment;
